// Import vue
import Vue from 'vue';
import i18n from "../dashboard/language";
// Import vue-components
import incidentsCalendar from './components/IncidentsCalendar'
import displayDate from './components/DisplayDate'
// Import Sentry
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
// Vendor plugins
require('../plugins');

// Configure Sentry
if (window.config.sentry_dsn) {
    Sentry.init({
        dsn: window.config.sentry_dsn,
        integrations: [new Integrations.Vue({Vue, attachProps: true})],
    });
}

// Define vue
new Vue({
    el: '#app',
    i18n,
    components: {
        incidentsCalendar: incidentsCalendar,
        displayDate: displayDate,
    }
});
